export const FAVORITE_CATEGORY_ID = '1ad60c22-2c49-4c9d-a1c4-6ba23d993cb1'
